<template>
  <a-select
    class="top-select"
    :loading="loadingList"
    allowClear
    show-search
    :filter-option="false"
    :defaultActiveFirstOption="false"
    @search="onSearchSelect"
    @change="handleInput"
    v-bind="{
      ...selectProps,
      defaultValue: selectProps.defaultValue
        ? selectProps.defaultValue
        : undefined,
    }"
  >
    <a-select-option v-if="!isEmptyQuery" disabled key="undefined">
      <a-spin v-if="loadingList" size="small" />
      <span v-else> Enter to search </span>
    </a-select-option>
    <a-select-option v-if="isEmptyQuery" disabled key="empty">
      <a-spin v-if="loadingList" size="small" />
      <span v-else>No search results found</span>
    </a-select-option>
    <a-select-option
      v-for="item in checkInitialDatasWithQueryData(datas, initialDatas)"
      :key="item.id"
    >
      {{ item.name }}
    </a-select-option>
  </a-select>
</template>
<script>
import query from "./constant/query";
import debounce from "lodash/debounce";

const limit = 20;
export default {
  props: {
    selectProps: {
      type: Object,
      default() {
        return {};
      },
    },
    initialDatas: {
      type: Array,
      default() {
        return [];
      },
    },
    variablesQuery: {
      type: Object,
      default() {
        return {};
      },
    },
    setValueResults: {
      type: Function,
      default: () => {},
    },
    setValueResultsAfterGetNew: {
      type: Function,
      default: () => {},
    },
    setLoading: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    this.onSearchSelect = debounce(this.onSearchSelect, 500);
    return {
      loadingList: false,
      loadingDone: false,
      isEmptyQuery: false,
      datas: [],
      filter: {},
      // all data has been exits in state
      allDatas: [],
    };
  },
  model: {
    event: "change",
  },
  watch: {
    loadingDone() {
      this.setLoading(this.loadingDone);
    },
  },
  created() {
    if (this.initialDatas?.length > 0) {
      this.datas = [...this.initialDatas];
    } else {
      this.onGetAllEmployee();
    }
  },
  methods: {
    handleInput(value) {
      this.$emit("change", value);
      if (value && Array.isArray(value) && value.length > 0) {
        let array = [];
        for (let i in value) {
          const find = this.allDatas.find((e) => e.id === value[i]);
          array.push(find);
        }

        this.setValueResults(array);
      } else {
        this.setValueResults(this.allDatas.filter((e) => e.id === value));
      }
    },
    onSearchSelect(input, option) {
      this.datas = [];
      this.$set(this.filter, "query", input);
      this.onGetAllEmployee();
    },
    checkInitialDatasWithQueryData(queryDatas, initialDatas) {
      if (initialDatas?.length > 0) {
        const uniqueInitialDatas = [];
        for (let i in initialDatas) {
          const item = initialDatas[i];
          const find = queryDatas.find((e) => e.id === item.id);
          if (!find) {
            uniqueInitialDatas.push(item);
          }
        }
        return [...queryDatas, ...uniqueInitialDatas];
      } else {
        return [...queryDatas];
      }
    },
    onGetAllEmployee() {
      this.loadingList = true;
      this.loadingDone = false;
      this.$apollo
        .query({
          query: query.getAllDepartment,
          fetchPolicy: "no-cache",
          variables: {
            query: this.filter.query,
            limit:
              typeof this.variablesQuery.limit !== "undefined"
                ? this.variablesQuery.limit
                : limit,
            page: 1,
            ...this.variablesQuery,
          },
        })
        .then(({ data }) => {
          if (data?.getAllDepartment?.length >= 0) {
            if (data?.getAllDepartment?.length > 0) {
              this.datas = [...data.getAllDepartment];
              this.isEmptyQuery = false;
              // push data for all datas
              for (let i in data.getAllDepartment) {
                if (
                  !this.allDatas.find((e) => e.id === data.getAllDepartment[i])
                ) {
                  this.allDatas.push(data.getAllDepartment[i]);
                }
              }
            } else {
              this.datas = [];
              this.isEmptyQuery = true;
            }
            // get value result if query new data
            this.setValueResultsAfterGetNew(data.getAllDepartment);
            this.loadingList = false;
            this.loadingDone = true;
          }
        })
        .catch((error) => {
          this.loadingList = false;
          console.error("Error get list", error);
        });
    },
  },
};
</script>
<style scoped>
.top-select .ant-select-disabled {
  color: #333 !important;
}
</style>
